import './QueuePage.scss';
import * as angular from 'angular';
import { QueueManagementConstants } from '../QueueManagementConstants';
import { QueuesTracks } from '../QueueManagementConstants';
import { ToastType } from 'modules/application/misc/ToastService';
import { AttendanceConstants } from '../../AttendanceConstants';
import { AttendanceFeatures } from '../../AttendanceFeatures';
import { characterLeftSquareBracketTreatment } from 'modules/application/detail/attendance/AttendanceUtils';
export class QueuePageController {
    static $inject = ['SegmentService', 'QueuesService', 'PermissionsService', 'application', '$translate', 'ngToast', '$stateParams', 'SavingService', '$timeout', 'TeamService', 'RulesService', 'DeskConfigurationService', '$state'];
    constructor(SegmentService, QueuesService, PermissionsService, application, $translate, ngToast, $stateParams, SavingService, $timeout, TeamService, RulesService, DeskConfigurationService, $state) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.QueuesService = QueuesService;
        this.PermissionsService = PermissionsService;
        this.application = application;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.$stateParams = $stateParams;
        this.SavingService = SavingService;
        this.$timeout = $timeout;
        this.TeamService = TeamService;
        this.RulesService = RulesService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.$state = $state;
        this.newQueue = true;
        this.inputTextSearchQueues = '';
        this.take = 999999;
        this.skip = 0;
        this.changeTitle = async (event) => {
            const title = event?.detail?.value.trim() ?? '';
            if (!title) {
                this.QueuesService.showToast('queue-management.errors.emptyFieldErrorMessage', ToastType.Warning);
                return;
            }
            await this.getQueues();
            const queueFilter = this.queuesList.find(queue => {
                return queue.name.toLowerCase() === title.toLowerCase();
            });
            if (queueFilter) {
                if (!this.queue.id || this.queue.id != queueFilter.id) {
                    this.QueuesService.showToast('queue-management.queues.warnningEdit', ToastType.Warning);
                    return;
                }
            }
            if (AttendanceConstants.DIRECT_TRANSFER_TEAM.toLowerCase() === title.toLowerCase()) {
                this.QueuesService.showToast('queue-management.queues.warnningCreateQueue', ToastType.Warning);
                return;
            }
            this.queue.name = title;
            if (!this.isManagerView) {
                await this.saveQueue();
            }
        };
    }
    async $onInit() {
        const isQueueManagementMfeEnabled = await AttendanceFeatures.isQueueManagementMfeEnabled();
        if (isQueueManagementMfeEnabled) {
            this.$state.go('auth.application.detail.attendance.desk.queueManagement');
            return;
        }
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        this.newQueue = true;
        this.queue = angular.copy(this.queue);
        this.hasWritingPermission = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
        this.trackPayload = { source: QueuesTracks.SOURCE.PORTAL };
        this.setIfPriorityIsEnabled();
        this.isTagsQueueFeaturetoggleEnabled = await AttendanceFeatures.isTagsQueueEnabled();
        if (this.$stateParams.id) {
            this.queueId = this.$stateParams.id;
            this.queue = await this.QueuesService.getQueue(this.queueId);
            this.queue.numberAttendants = await this.getNumberAttendants() || 0;
            this.queue.numberRules = await this.getNumberRules() || 0;
            this.newQueue = false;
        }
        else {
            this.queue = {
                id: '',
                isActive: true,
                name: this.$translate.instant('queue-management.queues.queueName'),
                numberAttendants: 0,
            };
            this.createNewQueueTrack();
        }
        await this.getQueues();
    }
    editNumberAttendants(countAttendant) {
        this.queue.numberAttendants = countAttendant;
    }
    editNumberRules(countRules) {
        this.queue.numberRules = countRules;
    }
    editNumberPriorityRules(countPriorityRules) {
        this.queue.numberPriorityRules = countPriorityRules;
    }
    async setIfPriorityIsEnabled() {
        this.isPriorityFeaturetoggleEnabled = await AttendanceFeatures.isPriorityAttendanceQueueEnabled();
        const isOrleansEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.ORLEANS_DISTRIBUTION;
        const isRedisEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.REDIS_DISTRIBUTION;
        this.isPriorityEnabled = this.isPriorityFeaturetoggleEnabled && (isOrleansEnabled || isRedisEnabled);
    }
    async getNumberAttendants() {
        if (this.isLoading) {
            return;
        }
        try {
            this.setIsLoading(true);
            this.queue.name = characterLeftSquareBracketTreatment(this.queue.name);
            const { total } = await this.TeamService.getAttendantsQueue(this.queue.name, this.skip, this.take);
            return total;
        }
        catch (e) {
            console.error(e);
            return 0;
        }
        finally {
            this.setIsLoading(false);
        }
    }
    async getNumberRules() {
        if (this.isLoading) {
            return;
        }
        try {
            this.setIsLoading(true);
            const { total } = await this.RulesService.getRulesQueue(this.queue.name, this.skip, this.take);
            return total;
        }
        catch (e) {
            console.error(e);
            return 0;
        }
        finally {
            this.setIsLoading(false);
        }
    }
    async getQueues() {
        try {
            const { items } = await this.QueuesService.getQueues(this.skip, this.take);
            this.queuesList = items ? items.map((item) => {
                item.numberAttendants = 0;
                return item;
            }) : [];
        }
        catch (e) {
            this.queuesList = [];
        }
    }
    async saveQueue() {
        if (!this.hasWritingPermission) {
            return;
        }
        this.SavingService.startSaving();
        try {
            this.queue = await this.QueuesService.save(this.queue);
            this.SegmentService.createApplicationTrack({ trackEvent: QueuesTracks.QUEUE_ADDED, application: this.application, payload: {} });
        }
        catch (error) {
            const errorMsg112 = await this.$translate('modules.application.detail.attendance.queue-management.warning');
            this.ngToast.danger(errorMsg112);
        }
        finally {
            this.$timeout(() => {
                this.SavingService.stopSaving();
            }, 500);
        }
        if (!this.newQueue) {
            this.QueuesService.showToast('queue-management.queues.confirmEdit', ToastType.Success);
        }
        else {
            this.QueuesService.showToast('queue-management.queues.confirmAddQueue', ToastType.Success);
        }
        this.newQueue = false;
    }
    createNewQueueTrack() {
        this.SegmentService.createBotTrack(QueuesTracks.ADD_QUEUE_CLICKED, this.application);
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    isQueueNameEditable() {
        return !this.queue?.numberAttendants && !this.queue?.numberRules;
    }
    openErrorEditToast() {
        if (this.queue.numberAttendants > 0) {
            this.QueuesService.showToast('queue-management.queues.warnningEditAttendant', ToastType.Warning);
            return;
        }
        if (this.queue.numberRules > 0) {
            this.QueuesService.showToast('queue-management.queues.warningEditRules', ToastType.Warning);
            return;
        }
    }
}
QueuePageController.$inject = ['SegmentService', 'QueuesService', 'PermissionsService', 'application', '$translate', 'ngToast', '$stateParams', 'SavingService', '$timeout', 'TeamService', 'RulesService', 'DeskConfigurationService', '$state'];
